module.exports = __webpack_public_path__ + "img/medal_vip6.af72389.png";